// // src/components/user/ServiceCard.jsx
// import React from 'react';
// import { FaCogs, FaBolt, FaMountain, FaBuilding, FaTruck } from 'react-icons/fa';

// const ServiceCard = ({ service }) => {
//   const getIcon = (category) => {
//     switch(category) {
//       case 'MINING':
//         return <FaMountain className="h-8 w-8" />;
//       case 'MECHANICAL':
//         return <FaCogs className="h-8 w-8" />;
//       case 'ELECTRICAL':
//         return <FaBolt className="h-8 w-8" />;
//       case 'CIVIL SERVICES':
//       case 'ARCHITECTURE':
//       case 'GENERAL CONSTRUCTION':
//         return <FaBuilding className="h-8 w-8" />;
//       default:
//         return <FaTruck className="h-8 w-8" />;
//     }
//   };

//   return (
//     <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
//       <div className="p-6">
//         <div className="flex items-center justify-between mb-4">
//           <div className="p-3 bg-blue-100 rounded-lg text-blue-600">
//             {getIcon(service.category)}
//           </div>
//           <span className="px-3 py-1 bg-gray-100 text-gray-600 text-sm font-medium rounded-full">
//             {service.category}
//           </span>
//         </div>
        
//         <h3 className="text-xl font-bold text-gray-800 mb-3">{service.title}</h3>
//         <p className="text-gray-600 mb-4 line-clamp-3">{service.description}</p>
        
//         <div className="space-y-2">
//           {service.details && service.details.services && (
//             <ul className="text-sm text-gray-500">
//               {service.details.services.slice(0, 3).map((item, index) => (
//                 <li key={index} className="flex items-center">
//                   <span className="h-1.5 w-1.5 bg-blue-500 rounded-full mr-2"></span>
//                   {item}
//                 </li>
//               ))}
//             </ul>
//           )}
//         </div>
        
//         <div className="mt-6 pt-4 border-t">
//           <button className="text-blue-600 hover:text-blue-800 font-medium flex items-center">
//             Learn More
//             <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//             </svg>
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ServiceCard;



// src/components/user/ServiceCard.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // Add this import
import { FaCogs, FaBolt, FaMountain, FaBuilding, FaTruck } from 'react-icons/fa';

const ServiceCard = ({ service }) => {
  const [imageError, setImageError] = useState(false);

  const getIcon = (category) => {
    switch(category?.toUpperCase().trim()) {
      case 'MINING':
        return <FaMountain className="h-6 w-6" />;
      case 'MECHANICAL':
        return <FaCogs className="h-6 w-6" />;
      case 'ELECTRICAL':
        return <FaBolt className="h-6 w-6" />;
      case 'CIVIL SERVICES':
      case 'ARCHITECTURE':
      case 'GENERAL CONSTRUCTION':
      case 'CONSTRUCTION':
        return <FaBuilding className="h-6 w-6" />;
      case 'AGRICULTURE':
      case 'AGRICULTURE ':
        return <FaTruck className="h-6 w-6" />;
      default:
        return <FaTruck className="h-6 w-6" />;
    }
  };

  // Check if image URL is valid
  const isValidImageUrl = (url) => {
    if (!url) return false;
    if (typeof url !== 'string') return false;
    const trimmedUrl = url.trim();
    return trimmedUrl.length > 0 && (trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://'));
  };

  const hasImage = isValidImageUrl(service.image_url) && !imageError;

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 h-full flex flex-col">
      {/* Image Section */}
      <div className="relative h-48 w-full overflow-hidden bg-gray-100">
        {hasImage ? (
          <img 
            src={service.image_url}
            alt={service.title || 'Service Image'}
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
            onError={() => setImageError(true)}
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center p-4">
            <div className="p-4 bg-blue-100 rounded-full text-blue-600 mb-3">
              {getIcon(service.category)}
            </div>
            <span className="text-sm font-medium text-gray-600 text-center">
              {service.category || 'Service'}
            </span>
          </div>
        )}
      </div>
      
      {/* Content Section */}
      <div className="p-6 flex-grow flex flex-col">
        <div className="flex justify-between items-start mb-3">
          <h3 className="text-xl font-bold text-gray-800 flex-grow pr-2 line-clamp-2">
            {service.title || 'Untitled Service'}
          </h3>
          <span className="px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full whitespace-nowrap flex-shrink-0 ml-2">
            {service.category || 'General'}
          </span>
        </div>
        
        <p className="text-gray-600 mb-4 line-clamp-3 flex-grow">
          {service.description || 'No description available.'}
        </p>
        
        {service.details?.services?.length > 0 && (
          <div className="mb-4">
            <h4 className="text-sm font-semibold text-gray-700 mb-2">Key Services:</h4>
            <ul className="text-sm text-gray-500 space-y-1">
              {service.details.services.slice(0, 3).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="h-1.5 w-1.5 bg-blue-500 rounded-full mt-2 mr-2 flex-shrink-0"></span>
                  <span className="line-clamp-2">{item}</span>
                </li>
              ))}
              {service.details.services.length > 3 && (
                <li className="text-blue-600 text-sm font-medium">
                  +{service.details.services.length - 3} more
                </li>
              )}
            </ul>
          </div>
        )}
        
        <div className="mt-4 pt-4 border-t border-gray-100">
          <Link 
            to={`/services/${service.id}`}
            className="text-blue-600 hover:text-blue-800 font-medium flex items-center text-sm group"
          >
            <span>Learn More</span>
            <svg 
              className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M9 5l7 7-7 7" 
              />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;